import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Task Service */
const addTask = (params) => {
    const dataParam = {
        type: 'upload',
    };
    const { axiosInstance, config } = getAxiosConfig(dataParam);
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.createTask}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get Task Service */
const getAllTask = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.getAllTasks}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Update Task Service */
const updateTask = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.updateTask}`,
        method: "PUT",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Delete Task Service */
const deleteTask = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.deleteTask}`,
        method: "DELETE",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Add Task Service */
const addSubTask = (params) => {
    const dataParam = {
        type: 'upload',
    };
    const { axiosInstance, config } = getAxiosConfig(dataParam);
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.createSubTask}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get Task Service */
const getAllSubTask = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.getAllSubTasks}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Update Task Service */
const updateSubTask = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.updateSubTask}`,
        method: "PUT",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Delete Task Service */
const deleteSubTask = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.deleteSubTask}`,
        method: "DELETE",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Add Task Project Service */
const addTaskProject = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.addTaskProject}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get Task Project Service */
const getTaskProject = (params) => {
    const { axiosInstance, config, } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.getTaskProject}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get All Task Project Service*/
const getAllTaskProjectList = (params) => {
    const { axiosInstance, config, } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.getAllTaskProjectList}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Update Task Project  Service */
const updateTaskProject = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.updateTaskProject}`,
        method: "PUT",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Delete Task Project  Service */
const deleteTaskProject = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.deleteTaskProject}`,
        method: "DELETE",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/*save Time Tracking  Service */
const saveTimeTracking = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.saveTimeTracking}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/*Get Task Logs  Service */
const getTaskLogs = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.getTaskLogs}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/*Task Report Service */
const taskReport = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.taskReport}`,
        method: "GET",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/*Task Report Service */
const taskStatus = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.taskStatus}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Employee Wise Task Service */
const employeeWiseTask = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.employeeWiseTask}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* change Status Service */
const changeStatus = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.changeStatus}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/*task Graph Service */
const taskGraph = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.taskGraph}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Change Due Date Service */
const changeDueDate = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.changeDueDate}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/*add Task File Service */
const addTaskFile = (params) => {
    const dataParam = {
        type: 'upload',
    };
    const { axiosInstance, config } = getAxiosConfig(dataParam);
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.addTaskFile}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/*add Task File Service */
const getTaskFile = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.getTaskFile}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/*Sub Task Status Service */
const subTaskStatus = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.subTaskStatus}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/*Sub Task Status Service */
const getMyTask = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.taskManagement.getMyTask}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

export default {
    addTask,
    getAllTask,
    updateTask,
    deleteTask,
    addSubTask,
    getAllSubTask,
    updateSubTask,
    deleteSubTask,
    addTaskProject,
    getTaskProject,
    getAllTaskProjectList,
    updateTaskProject,
    deleteTaskProject,
    saveTimeTracking,
    getTaskLogs,
    taskReport,
    taskStatus,
    employeeWiseTask,
    taskGraph,
    changeStatus,
    changeDueDate,
    addTaskFile,
    getTaskFile,
    subTaskStatus,
    getMyTask

}